import { toast } from 'react-hot-toast';
import { PaymentType, TransactionEvidenceEntity } from '../@types';
import { paymentService } from '../services';
import { PaymentCredential } from '../types';

export const getPaymentHistory = async (entity: string) => {
  try {
    const res = await paymentService.get(`/payment/entity/${entity}`);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const createPaymentCredential = async (data: PaymentCredential) => {
  try {
    const res = await paymentService.post(`/provider/payment`, data);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    throw new Error(e.response?.data || e.message);
  }
};

export const getPaymentCredential = async () => {
  try {
    const res = await paymentService.get(`/provider/payment`);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    throw new Error(e.response?.data || e.message);
  }
};

export const updatePaymentCredential = async (data: PaymentCredential) => {
  try {
    const res = await paymentService.patch(`/provider/payment/update`, data);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    throw new Error(e.response?.data || e.message);
  }
};

export const recordManualPayment = async (input: {
  amount: number;
  paymentType: PaymentType;
  paymentDate: string | Date | number;
  entityId: string;
  customerId: string;
  entityType: string;
  companyId:string;
  outletId:string;
}) => {
  const data = {
    ...input,
   
  };

  try {
    const res = await paymentService.post(`/payment`, data);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const generateUploadURL = async (input: TransactionEvidenceEntity) => {
  console.log({ input });
  const data: TransactionEvidenceEntity = {
    ...input,
  };
  try {
    const res = await paymentService.post(`/payment/evidence`, data);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const generatePaymentLink = async (data: PaymentCredential) => {
  try {
    const res = await paymentService.post(`/provider/payment/link`, data);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const convertExpense = async (id: string) => {
  try {
    const res = await paymentService.patch(`/expenses/${id}/convert`);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};
